
import Category from './Category/Category';
import { motion, AnimatePresence } from "framer-motion"

function Categories(props) {
  return (
    <div >
        {props.data && ( props.data.map((item, index)=>{
          return(
            <AnimatePresence>
              <motion.div
                initial={{ opacity: props.delay ? 1 : 0 }} // Start from 50px below the bottom
                animate={{ opacity: props.delay ? 0 : 1 }} // Slide up to its original position
                transition={{ duration: 0.3 }}
              >
                <Category 
                  key={index} 
                  item={item}
                  selectedServices={props.selectedServices}
                  onServiceSelect={props.onServiceSelect} onServiceDeSelect={props.onServiceDeSelect}
                  currentStep={props.currentStep}
                />
              </motion.div>
            </AnimatePresence>
          ) 
        })) }
    </div>


  );
}

export default Categories;